import type { DeadlineField } from '@stages/stages';
import type { ReviewCheckModalProjectPayload } from '@/api/client';
import type { ProductionHandoffIntroPhrase } from '@/constants/productionHandoffIntroPhrases';
import { reviewDeadlineDisplayToApi } from '@/utils/emailDateUtils';

export interface ProductionHandoffFormState {
  note: string;
  introPhrase: ProductionHandoffIntroPhrase;
  deadlineField: DeadlineField;
  /** Дата срока из поля, дд.мм.гггг; пусто — срок снимается */
  deadlineDate: string;
}

/** Тело `modal_project` письма «Передать в производство»: выбранный срок и его дата идут парой */
export function buildProductionHandoffModalPayload(
  form: ProductionHandoffFormState
): Omit<ReviewCheckModalProjectPayload, 'email_attachment_file_ids'> {
  return {
    studio_contractor_id: null,
    asta: null,
    edition_id: null,
    editor_id: null,
    edition_department_code: null,
    edition_name: null,
    time: null,
    tracks_count: null,
    size: null,
    note: form.note.trim() || null,
    deadline_field: form.deadlineField,
    deadline_date: reviewDeadlineDisplayToApi(form.deadlineDate),
    intro_phrase: form.introPhrase,
  };
}
